<template>
	<v-container>
		<v-row justify="center" align="center">
 			<v-card class="ma-3" cols="12" sm="10" md="8" lg="6" ref="form" >
 				<v-card-text>
 					<v-form enctype="multipart/form-data" @submit.prevent="create">
 						<v-row>
 							<v-col class="py-2">
		 						<!-- Scama name -->
		            <v-text-field
		              hide-details
			            outlined
			            v-model="form.name"
			            :label="this.$t('prvScama.create.scamaName')"
			            prepend-inner-icon="mdi-file"
				        ></v-text-field>
				        <template v-if="errors.name">
							    <span class="errorItem">{{errors.name[0]}}</span>
							    <br>
							  </template>
						  </v-col>
					  </v-row>
					  <!-- Image Tutorial -->
						<v-row>
	   					<v-img src="https://i.imgur.com/TAKpxZM.png"></v-img>
	   				</v-row>

	   				<!-- Image Uplaod/Link -->
				    <v-row>
				    	<v-col class="py-2" cols="6">
					    	<v-switch
						      v-model="switch1"
						      :label="this.$t('prvScama.create.imgUpload')"
						    ></v-switch>
							</v-col>

              <v-col class="py-2" cols="6">
                <v-file-input v-if="switch1"
                	hide-details
							    :rules="rules"
							    @change="selectPhoto"
							    accept="image/png, image/jpeg, image/bmp"
							    persistent-placeholder
							    :placeholder="this.$t('prvScama.create.pickPhoto')"
							    prepend-icon="mdi-camera"
							    :label="this.$t('prvScama.create.photo')"
							  ></v-file-input>

							  <v-text-field v-else
							  	hide-details
							  	persistent-placeholder
                	placeholder="http://example.com/image.png"
			            :label="this.$t('prvScama.create.imgLink')"
			            v-model="form.photo"
			            prepend-icon="mdi-camera"
				        ></v-text-field>

			    			<template v-if="errors.photo">
							    <span class="errorItem">{{errors.photo[0]}}</span>
							    <br>
							  </template>
              </v-col>
          	</v-row>
          	<v-row>
          		<v-col class="py-2">
		          	<!-- Letter -->
		            <v-text-field
		              hide-details
			            outlined
			            :label="this.$t('prvScama.create.letter')"
			            v-model="form.title"
			            prepend-inner-icon="mdi-format-align-left"
				        ></v-text-field>
				        <template v-if="errors.title">
							    <span class="errorItem">{{errors.title[0]}}</span>
							    <br>
							  </template>
						  </v-col>
						</v-row>
						<v-row>
							<!-- Label 1 -->
							<v-col class="py-2" cols="6">
								<v-text-field
			            outlined
			            hide-details
			            :label="this.$t('prvScama.create.label_1')"
			            v-model="form.label_1"
			            prepend-inner-icon="mdi-format-align-left"
				        ></v-text-field>
						    <template v-if="errors.label_1">
							    <span class="errorItem">{{errors.label_1[0]}}</span>
							    <br>
							  </template>
					    </v-col>

					    <!-- Label 2 -->
					    <v-col class="py-2" cols="6">
						    <v-text-field
			            outlined
			            hide-details
			            :label="this.$t('prvScama.create.label_2')"
			            v-model="form.label_2"
			            prepend-inner-icon="mdi-format-align-left"
				        ></v-text-field>
						    <template v-if="errors.label_2">
							    <span class="errorItem">{{errors.label_2[0]}}</span>
							    <br>
							  </template>
					    </v-col>
						</v-row>
						<v-row>
							<v-col class="py-2">
								<!-- Button Name -->
								<v-text-field
			            outlined
			            hide-details
			            :label="this.$t('prvScama.create.btnName')"
			            v-model="form.btn"
			            prepend-inner-icon="mdi-format-align-left"
				        ></v-text-field>
					    	<template v-if="errors.btn">
							    <span class="errorItem">{{errors.btn[0]}}</span>
							    <br>
							  </template>
						  </v-col>
					  </v-row>
					  <br>
            <v-btn x-large block type="submit" color="primary"> {{$t('prvScama.create.create')}} </v-btn></v-form>
  			</v-card-text>
  		</v-card>

  	<!-- Loading -->
    <v-overlay :value="isLoading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

  	</v-row>
  </v-container>
</template>

<style scoped>
.errorItem{
	color:red; 
	float:left
}
</style>

<script>
  import PrivateScama from "@/apis/PrivateScama";

  export default {
  	name: 'prvCreate',
    data(){
    	return {
    		isLoading: false,
    		form: {
					name: '',
					photo : '',
					title: '',
					label_1: '',
					label_2: '',
					btn:''
				},
				errors: [],
				rules: [
	        value => !value || value.size < 2000000 || 'Photo size should be less than 2 MB!',
	      ],
			  switch1: false,
				show: false,
			}
    },

    methods: {

    	/**
    	*	Create new Private Scama
    	*/
      create () {
      	this.isLoading = true;
      	let formData = new FormData();

				for ( let key in this.form ) {
			    formData.append(key, this.form[key]);
				}

        PrivateScama.create(formData)
				.then(() => {
					this.$router.push({name : "prvIndex"});
					this.isLoading = false;
				})
				.catch(error => {
					if(error.response.status === 422){
						this.errors = error.response.data.errors;
					}
					this.isLoading = false;
				});
      },

      /**
      * Upload new Photo
      */
      selectPhoto(event){
      	this.form.photo = event;
      },

      /**
      *	Reset Form
      */
      reset () {
        this.$refs.form.reset()
      },

      /**
      * Reset Validation
      */
      resetValidation () {
        this.$refs.form.resetValidation()
      },
    },
  };
</script>